export default __webpack_public_path__ + "static/media/03.f232cf1f.svg";